<template>
  <div>
    <el-collapse v-model="activeNames" style="width: 100%">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
      <el-collapse-item
        v-show="activeType == 1"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="菜单设置"
        name="1"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <div class="verticallyCenter">
            <span class="mr16">排列方向</span>
            <div class="font-arrangement-btn flex1">
              <span class="btn-active" :style="getTranslate"></span>
              <el-tooltip
                v-for="(val, index) in directionList"
                :key="index"
                class="item"
                effect="dark"
                :content="val.title"
                placement="top-end"
                :open-delay="1000"
              >
                <span
                  :key="index"
                  :class="directionMode == val.label ? 'select pd2' : 'pd2'"
                  @click="changeDirection(val.label)"
                  ><i :class="val.className"></i
                ></span>
              </el-tooltip>
            </div>
          </div>
          <div class="verticallyCenter mt12" v-if="directionMode === 'vertical'">
            <span class="mr16">每页列数</span>
            <div class="verticallyCenter set-box">
              <input
                class="el-input__inner"
                type="number"
                @focus="getFocus($event)"
                style="width: 80px; height: 32px; flex: 1"
                min="1"
                max="10"
                v-model="showColNumber"
              />
              <div class="btn-wrapper">
                <span
                  :class="showColNumber === 1 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                  @click="changeColLen(0)"
                ></span>
                <span
                  :class="showColNumber === 10 ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
                  class="num-btn icon-portal-plus"
                  @click="changeColLen(1)"
                ></span>
              </div>
            </div>
          </div>
          <div class="verticallyCenter mt12" v-if="directionMode === 'vertical'">
            <span class="mr16">列宽设置</span>
            <div class="font-arrangement-btn flex1">
              <span class="btn-active" :style="getTranslate1"></span>
              <el-tooltip
                v-for="(val, index) in widthTypeList"
                :key="index"
                class="item"
                effect="dark"
                :content="val.title"
                placement="top-end"
                :open-delay="1000"
              >
                <span
                  :key="index"
                  :class="widthAuto == val.label ? 'select pd2 fs13' : 'pd2 fs13'"
                  @click="changeWidthType(val.label)"
                  >{{ val.title }}</span
                >
              </el-tooltip>
            </div>
          </div>
          <div class="mt8" v-if="!widthAuto && directionMode === 'vertical'">
            <div v-for="(value, index) in widthList" :key="index" class="mt4">
              <slider-and-input
                :value="value"
                :title="'第' + (index + 1) + '列'"
                :sliderMax="100"
                :sliderMin="1"
                suffix="%"
                @change="changeWidthHandle($event, index)"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="activeType == 1 && directionMode === 'vertical'"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
        title="切换设置"
        name="2"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <div class="verticallyCenter">
            <span class="mr16">切换方式</span>
            <div class="font-arrangement-btn flex1">
              <span class="btn-active" :style="getTranslate2"></span>
              <el-tooltip
                v-for="(val, index) in changeWayList"
                :key="index"
                class="item"
                effect="dark"
                :content="val.title"
                placement="top-end"
                :open-delay="1000"
              >
                <span
                  :key="index"
                  :class="changeWay == val.label ? 'select pd2 fs13' : 'pd2 fs13'"
                  @click="handleChangeWay(val.label)"
                  >{{ val.title }}
                </span>
              </el-tooltip>
            </div>
          </div>
          <div v-if="changeWay === 'button'">
            <Button :ids="ids" :options="options" />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="activeType == 1"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
        title="一级菜单"
        name="3"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
          <slider-and-input
            class="mb8"
            v-if="directionMode === 'horizontal'"
            inputWidth="small"
            inputHeight="small"
            :value.sync="navWidth"
            title=""
            titlePosition="singleLine"
            :sliderMax="500"
            suffix="px"
          />
          <div>
            <span class="fs14">文字样式</span>
            <text-setting-complex-update
              class="mt8"
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
              :fontStyle.sync="fontStyle"
              :textDecoration.sync="textDecoration"
              :lineHeight.sync="lineHeight"
              :lineHeightType.sync="lineHeightType"
              :letterSpacing.sync="letterSpacing"
              :activeArrangement.sync="arrangement"
              :writingMode.sync="writingMode"
              :textAlign.sync="textAlign"
              :activeArrangementOrder.sync="arrangementOrder"
              :isThemeColor.sync="textIsThemeColor" 
              :colorArr.sync="color"
              :verticalAlign.sync="verticalAlign"
              :enableVerticalAlign="showVerticalAlign"
              :showOverflowSetting="true"
              :overflowTypes="['字数', '无']"
              :contentHasLimit.sync="topNavTextLimit"
              :contentHasLimitRadio="'字数'"
              :textLimitWords.sync="topNavTextLimitCount"
              :options="options"
            />
          </div>
          <div class="mt12">
            <el-checkbox v-model="showTopNavIcon">显示图标</el-checkbox>
            <div v-show="showTopNavIcon" class="content-item card mt8">
              <img-icon-upload
                class="mb12"
                :imgSrc.sync="iconSrc"
                :iconType.sync="iconType"
                :iconColor.sync="iconColor"
                :resInfo.sync="resInfo"
              />
              <div v-show="iconSrc.length" class="content-item mb12 verticallyCenter">
                <span class="mr16 fs14">位置</span>
                <el-radio-group v-model="iconPosition">
                  <el-radio label="left">左</el-radio>
                  <el-radio label="right">右</el-radio>
                </el-radio-group>
              </div>
              <slider-and-input class="mb12" :value.sync="iconMargin" title="间距" :sliderMax="navWidth" suffix="px" />
              <div class="verticallyCenter mb12" v-if="iconType === 'icon'">
                <span class="mr16 fs14">颜色</span>
                <cx-color-picker class="flex1" :isThemeColor.sync="iconColorIsThemeColor" :colorArr.sync="iconColor">
                </cx-color-picker>
              </div>
              <slider-and-input :value.sync="iconWidth" title="大小" :sliderMax="navWidth" suffix="px" />
            </div>
          </div>
          <border-radius
            class="mt12"
            :borderTypeFlag.sync="topNavBorderTypeFlag"
            :borderRadius.sync="topNavBorderRadius"
            :borderTopLeftRadius.sync="topNavBorderTopLeftRadius"
            :borderTopRightRadius.sync="topNavBorderTopRightRadius"
            :borderBottomRightRadius.sync="topNavBorderBottomRightRadius"
            :borderBottomLeftRadius.sync="topNavBorderBottomLeftRadius"
          />
          <div class="mt12">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="topNavBorderWidth"
              :borderStyle.sync="topNavBorderStyle"
              :borderColor.sync="topNavBorderColor"
              :borderIsThemeColor.sync="topNavBorderIsThemeColor"
            />
          </div>
          <div class="mt12">
            <cx-padding
              :paddingTypeFlag.sync="topNavPaddingTypeFlag"
              :padding.sync="topNavPadding"
              :paddingTop.sync="topNavPaddingTop"
              :paddingRight.sync="topNavPaddingRight"
              :paddingBottom.sync="topNavPaddingBottom"
              :paddingLeft.sync="topNavPaddingLeft"
            />
          </div>
          <div class="mt12">
            <cx-background :background.sync="topNavBackground" imgType="10" />
          </div>
          <div class="mt12">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('topNavB')"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="topNavBoxShadowH"
              :boxShadowV.sync="topNavBoxShadowV"
              :boxShadowBlur.sync="topNavBoxShadowBlur"
              :boxShadowSpread.sync="topNavBoxShadowSpread"
              :boxShadowColor.sync="topNavBoxShadowColor"
            ></box-shadow>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="activeType == 1"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
        title="二级菜单"
        name="4"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
          <div class="content-item mb12 verticallyTop" v-if="directionMode === 'horizontal'">
            <span class="mr8 mt6">间距</span>
            <div class="content-item mr8 flex1">
              <single-input :value.sync="lineMargin" inputSuffixs="px" />
              <p class="fs12 mt8 ml12 setting-item-txt">行间距</p>
            </div>
            <div class="content-item flex1">
              <single-input :value.sync="columnMargin" inputSuffixs="px" />
              <p class="fs12 mt8 ml12 setting-item-txt">列间距</p>
            </div>
          </div>
          <div class="">
            <span class="inlineMiddle">文字样式</span>
            <text-setting-complex-update
              class="mt8"
              :fontFamily.sync="liFontFamily"
              :fontSize.sync="liFontSize"
              :fontWeight.sync="liFontWeight"
              :fontStyle.sync="liFontStyle"
              :textDecoration.sync="liTextDecoration"
              :lineHeight.sync="liLineHeight"
              :lineHeightType.sync="liLineHeightType"
              :letterSpacing.sync="liLetterSpacing"
              :activeArrangement.sync="liArrangement"
              :writingMode.sync="liWritingMode"
              :textAlign.sync="liTextAlign"
              :activeArrangementOrder.sync="liArrangementOrder"
              :isThemeColor.sync="liIsThemeColor" 
              :colorArr.sync="liFontColor"
              :verticalAlign.sync="liVerticalAlign"
              :enableVerticalAlign="showLiVerticalAlign"
              :showOverflowSetting="true"
              :overflowTypes="['字数', '无']"
              :contentHasLimit.sync="liTextLimit"
              :contentHasLimitRadio="'字数'"
              :textLimitWords.sync="liTextLimitCount"
              :options="options"
            />
          </div>
          <div class="mt12">
            <el-checkbox v-model="showLiNavIcon">显示图标</el-checkbox>
            <div v-show="showLiNavIcon" class="content-item card mt8">
              <img-icon-upload
                class="mb12"
                :imgSrc.sync="liIconSrc"
                :iconType.sync="liIconType"
                :iconColor.sync="liIconColor"
                :resInfo.sync="liResInfo"
              />
              <div v-show="liIconSrc.length" class="content-item mb12 verticallyCenter">
                <span class="mr16 fs14">位置</span>
                <el-radio-group v-model="liIconPosition">
                  <el-radio label="left">左</el-radio>
                  <el-radio label="right">右</el-radio>
                </el-radio-group>
              </div>
              <slider-and-input
                class="mb12"
                :value.sync="liIconMargin"
                title="间距"
                :sliderMax="navWidth"
                suffix="px"
              />
              <div class="verticallyCenter mb12" v-if="liIconType === 'icon'">
                <span class="mr16 fs14">颜色</span>
                <cx-color-picker
                  class="flex1"
                  :isThemeColor.sync="liIconColorIsThemeColor"
                  :colorArr.sync="liIconColor"
                >
                </cx-color-picker>
              </div>
              <slider-and-input :value.sync="liIconWidth" title="大小" :sliderMax="navWidth" suffix="px" />
            </div>
          </div>
          <border-radius
            class="mt12"
            :borderTypeFlag.sync="liBorderTypeFlag"
            :borderRadius.sync="liBorderRadius"
            :borderTopLeftRadius.sync="liBorderTopLeftRadius"
            :borderTopRightRadius.sync="liBorderTopRightRadius"
            :borderBottomRightRadius.sync="liBorderBottomRightRadius"
            :borderBottomLeftRadius.sync="liBorderBottomLeftRadius"
          />
          <div class="mt16">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="liBorderWidth"
              :borderStyle.sync="liBorderStyle"
              :borderColor.sync="liBorderColor"
              :borderIsThemeColor.sync="liBorderIsThemeColor"
            />
          </div>
          <div class="mt12">
            <cx-padding
              :paddingTypeFlag.sync="liPaddingTypeFlag"
              :padding.sync="liPadding"
              :paddingTop.sync="liPaddingTop"
              :paddingRight.sync="liPaddingRight"
              :paddingBottom.sync="liPaddingBottom"
              :paddingLeft.sync="liPaddingLeft"
            />
          </div>
          <div class="mt12">
            <cx-background :background.sync="liBackground" imgType="10" />
          </div>
          <div class="content-item mt12">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('liB')"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="liBoxShadowH"
              :boxShadowV.sync="liBoxShadowV"
              :boxShadowBlur.sync="liBoxShadowBlur"
              :boxShadowSpread.sync="liBoxShadowSpread"
              :boxShadowColor.sync="liBoxShadowColor"
            ></box-shadow>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="activeType == 1"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
        title="更多按钮"
        name="5"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')">
          <div>
            <el-input
                class="mt8"
                style="height: 32px"
                v-model="moreContent"
                placeholder="请输入"
                type="text"
                @focus="getFocus($event)"
            />
            <span class="mr16">文字内容</span>
<!--            <single-input class="mt8" style="height: 32px" :value.sync="moreContent" -->
<!--                          :noInputSuffixs="true" />-->
          </div>
          <div class="mt12">
            <span class="inlineMiddle">文字样式</span>
            <text-setting-complex-update
              class="mt8"
              :fontFamily.sync="moreFontFamily"
              :fontSize.sync="moreFontSize"
              :fontWeight.sync="moreFontWeight"
              :fontStyle.sync="moreFontStyle"
              :textDecoration.sync="moreTextDecoration"
              :lineHeight.sync="moreLineHeight"
              :lineHeightType.sync="moreLineHeightType"
              :letterSpacing.sync="moreLetterSpacing"
              :activeArrangement.sync="moreArrangement"
              :writingMode.sync="moreWritingMode"
              :textAlign.sync="moreTextAlign"
              :activeArrangementOrder.sync="moreArrangementOrder"
              :isThemeColor.sync="moreIsThemeColor" 
              :colorArr.sync="moreFontColor"
              :verticalAlign.sync="liVerticalAlign"
              :showOverflowSetting="true"
              :overflowTypes="['字数', '无']"
              :contentHasLimit.sync="moreTextLimit"
              :contentHasLimitRadio="'字数'"
              :textLimitWords.sync="moreTextLimitCount"
              :options="options"
            />
            <!-- <text-vertical-align-setting class="mt8" v-show="showActiveLiVerticalAlign" :verticalAlign.sync="liActiveVerticalAlign"/> -->
          </div>
          <div class="mt12">
            <el-checkbox v-model="showMoreNavIcon">显示图标</el-checkbox>
            <div v-show="showMoreNavIcon" class="content-item card mt8">
              <img-icon-upload
                class="mb12"
                :imgSrc.sync="moreIconSrc"
                :iconType.sync="moreIconType"
                :iconColor.sync="moreIconColor"
                :resInfo.sync="moreResInfo"
              />
              <div v-show="moreIconSrc.length" class="content-item mb12 verticallyCenter">
                <span class="mr16 fs14">位置</span>
                <el-radio-group v-model="moreIconPosition">
                  <el-radio label="left">左</el-radio>
                  <el-radio label="right">右</el-radio>
                </el-radio-group>
              </div>
              <slider-and-input
                class="mb12"
                :value.sync="moreIconMargin"
                title="间距"
                :sliderMax="navWidth"
                suffix="px"
              />
              <div class="verticallyCenter mb12" v-if="moreIconType === 'icon'">
                <span class="mr16 fs14">颜色</span>
                <cx-color-picker
                  class="flex1"
                  :isThemeColor.sync="moreIconColorIsThemeColor"
                  :colorArr.sync="moreIconColor"
                >
                </cx-color-picker>
              </div>
              <slider-and-input :value.sync="moreIconWidth" title="大小" :sliderMax="navWidth" suffix="px" />
            </div>
          </div>
          <border-radius
            class="mt12"
            :borderTypeFlag.sync="moreBorderTypeFlag"
            :borderRadius.sync="moreBorderRadius"
            :borderTopLeftRadius.sync="moreBorderTopLeftRadius"
            :borderTopRightRadius.sync="moreBorderTopRightRadius"
            :borderBottomRightRadius.sync="moreBorderBottomRightRadius"
            :borderBottomLeftRadius.sync="moreBorderBottomLeftRadius"
          />
          <div class="mt16">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="moreBorderWidth"
              :borderStyle.sync="moreBorderStyle"
              :borderColor.sync="moreBorderColor"
              :borderIsThemeColor.sync="moreBorderIsThemeColor"
            />
          </div>
          <div class="mt12">
            <cx-padding
              :paddingTypeFlag.sync="morePaddingTypeFlag"
              :padding.sync="morePadding"
              :paddingTop.sync="morePaddingTop"
              :paddingRight.sync="morePaddingRight"
              :paddingBottom.sync="morePaddingBottom"
              :paddingLeft.sync="morePaddingLeft"
            />
          </div>
          <div class="mt12">
            <cx-background :background.sync="moreBackground" imgType="10" />
          </div>
          <div class="content-item mt12">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('moreB')"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="moreBoxShadowH"
              :boxShadowV.sync="moreBoxShadowV"
              :boxShadowBlur.sync="moreBoxShadowBlur"
              :boxShadowSpread.sync="moreBoxShadowSpread"
              :boxShadowColor.sync="moreBoxShadowColor"
            ></box-shadow>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-show="activeType == 1"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
        title="外观"
        name="6"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')">
          <div class="content">
            <div class="verticallyCenter">
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="opacity"
                title="透明度"
                :sliderMax="100"
                suffix="%"
              />
            </div>
            <div class="content-item mt12">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              />
            </div>
            <div class="content-item mt12 clearFloat">
              <div class="checkbox_colorPicker_container mb16">
                <span class="fs14">边框</span>
              </div>
              <cx-border
                :borderWidth.sync="borderWidth"
                :borderStyle.sync="borderStyle"
                :borderColor.sync="borderColor"
                :borderIsThemeColor.sync="borderIsThemeColor"
              />
            </div>
            <div class="mt12">
              <cx-padding
                :paddingTypeFlag.sync="paddingTypeFlag"
                :padding.sync="padding"
                :paddingTop.sync="paddingTop"
                :paddingRight.sync="paddingRight"
                :paddingBottom.sync="paddingBottom"
                :paddingLeft.sync="paddingLeft"
              />
            </div>
            <!-- <cx-slider class="mt16" label="对齐" :value.sync="alignmentType" :options="alignmentTypeOptions" :showToolTip="true"/> -->
            <div class="content-item mt12">
              <cx-background :background.sync="background" imgType="10" />
            </div>
            <div class="content-item mt12">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('b')"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
            <!-- <div class="content-item mt16">
              <el-checkbox v-model="isWrap">允许换行</el-checkbox>
              <div class="verticallyCenter mt16" v-if="isWrap">
                <span class="fs14 mr16">下间距</span>
                <div style="width: calc(100% - 70px)">
                  <slider-and-input
                    inputWidth="small"
                    inputHeight="small"
                    :value.sync="navMarginBottom"
                    title=""
                    titlePosition="singleLine"
                    :sliderMax="100"
                    suffix="px"
                  />
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="activeType == 2"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
        title="一级菜单"
        name="7"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')">
          <text-setting-complex-update
            :fontFamily.sync="activeFontFamily"
            :fontSize.sync="activeFontSize"
            :fontWeight.sync="activeFontWeight"
            :fontStyle.sync="activeFontStyle"
            :textDecoration.sync="activeTextDecoration"
            :lineHeight.sync="activeLineHeight"
            :lineHeightType.sync="activeLineHeightType"
            :letterSpacing.sync="activeLetterSpacing"
            :activeArrangement.sync="activeArrangement"
            :writingMode.sync="activeWritingMode"
            :textAlign.sync="activeTextAlign"
            :activeArrangementOrder.sync="activeArrangementOrder"
            :isThemeColor.sync="activeTextIsThemeColor" 
            :colorArr.sync="activeFontColor"
            :verticalAlign.sync="activeVerticalAlign"
            :enableVerticalAlign="showActiveVerticalAlign"
            :options="options"
          />
          <!-- <div class="mt12">
            <el-checkbox v-model="activeShowTopNavIcon">显示图标</el-checkbox>
            <div v-show="activeShowTopNavIcon" class="content-item card mt8">
              <img-icon-upload
                class="mb12"
                :imgSrc.sync="activeIconSrc"
                :iconType.sync="activeIconType"
                :iconColor.sync="activeIconColor"
                :resInfo.sync="activeResInfo"
              />
              <div v-show="activeIconSrc.length" class="content-item mb12 verticallyCenter">
                <span class="mr16 fs14">位置</span>
                <el-radio-group v-model="activeIconPosition">
                  <el-radio label="left">左</el-radio>
                  <el-radio label="right">右</el-radio>
                </el-radio-group>
              </div>
              <slider-and-input class="mb12" :value.sync="activeIconMargin" title="间距" :sliderMax="navWidth" suffix="px" />
              <div class="verticallyCenter mb12" v-if="activeIconType === 'icon'">
                <span class="mr16 fs14">颜色</span>
                <cx-color-picker class="flex1" :isThemeColor.sync="activeIconColorIsThemeColor" :colorArr.sync="activeIconColor">
                </cx-color-picker>
              </div>
              <slider-and-input :value.sync="activeIconWidth" title="大小" :sliderMax="navWidth" suffix="px" />
            </div>
          </div> -->
          <border-radius
            class="mt12"
            :borderTypeFlag.sync="activeTopNavBorderTypeFlag"
            :borderRadius.sync="activeTopNavBorderRadius"
            :borderTopLeftRadius.sync="activeTopNavBorderTopLeftRadius"
            :borderTopRightRadius.sync="activeTopNavBorderTopRightRadius"
            :borderBottomRightRadius.sync="activeTopNavBorderBottomRightRadius"
            :borderBottomLeftRadius.sync="activeTopNavBorderBottomLeftRadius"
          />
          <div class="mt12">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="activeTopNavBorderWidth"
              :borderStyle.sync="activeTopNavBorderStyle"
              :borderColor.sync="activeTopNavBorderColor"
              :borderIsThemeColor.sync="activeTopNavBorderIsThemeColor"
            />
          </div>
          <div class="mt12">
            <cx-padding
              :paddingTypeFlag.sync="activeTopNavPaddingTypeFlag"
              :padding.sync="activeTopNavPadding"
              :paddingTop.sync="activeTopNavPaddingTop"
              :paddingRight.sync="activeTopNavPaddingRight"
              :paddingBottom.sync="activeTopNavPaddingBottom"
              :paddingLeft.sync="activeTopNavPaddingLeft"
            />
          </div>
          <div class="mt16">
            <cx-background :background.sync="activeBgColor" imgType="10" />
          </div>
          <div class="mt12">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('activeTopNavB')"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="activeTopNavBoxShadowH"
              :boxShadowV.sync="activeTopNavBoxShadowV"
              :boxShadowBlur.sync="activeTopNavBoxShadowBlur"
              :boxShadowSpread.sync="activeTopNavBoxShadowSpread"
              :boxShadowColor.sync="activeTopNavBoxShadowColor"
            ></box-shadow>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="activeType == 2"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
        title="二级菜单"
        name="8"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '8')">
          <div class="">
            <span class="inlineMiddle">文字样式</span>
            <text-setting-complex-update
              class="mt8"
              :fontFamily.sync="liActiveFontFamily"
              :fontSize.sync="liActiveFontSize"
              :fontWeight.sync="liActiveFontWeight"
              :fontStyle.sync="liActiveFontStyle"
              :textDecoration.sync="liActiveTextDecoration"
              :lineHeight.sync="liActiveLineHeight"
              :lineHeightType.sync="liActiveLineHeightType"
              :letterSpacing.sync="liActiveLetterSpacing"
              :activeArrangement.sync="liActiveArrangement"
              :writingMode.sync="liActiveWritingMode"
              :textAlign.sync="liActiveTextAlign"
              :activeArrangementOrder.sync="liActiveArrangementOrder"
              :isThemeColor.sync="liActiveIsThemeColor" 
              :colorArr.sync="liActiveFontColor"
              :verticalAlign.sync="liActiveVerticalAlign"
              :enableVerticalAlign="showActiveLiVerticalAlign"
              :options="options"
            />
          </div>
          <!-- <div class="mt12">
            <el-checkbox v-model="activeShowLiNavIcon">显示图标</el-checkbox>
            <div v-show="activeShowLiNavIcon" class="content-item card mt8">
              <img-icon-upload
                class="mb12"
                :imgSrc.sync="liActiveIconSrc"
                :iconType.sync="liActiveIconType"
                :iconColor.sync="liActiveIconColor"
                :resInfo.sync="liActiveResInfo"
              />
              <div v-show="liActiveIconSrc.length" class="content-item mb12 verticallyCenter">
                <span class="mr16 fs14">位置</span>
                <el-radio-group v-model="liActiveIconPosition">
                  <el-radio label="left">左</el-radio>
                  <el-radio label="right">右</el-radio>
                </el-radio-group>
              </div>
              <slider-and-input class="mb12" :value.sync="liActiveIconMargin" title="间距" :sliderMax="navWidth" suffix="px" />
              <div class="verticallyCenter mb12" v-if="liActiveIconType === 'icon'">
                <span class="mr16 fs14">颜色</span>
                <cx-color-picker class="flex1" :isThemeColor.sync="liActiveIconColorIsThemeColor" :colorArr.sync="liActiveIconColor">
                </cx-color-picker>
              </div>
              <slider-and-input :value.sync="liActiveIconWidth" title="大小" :sliderMax="navWidth" suffix="px" />
            </div>
          </div> -->
          <border-radius
            class="mt12"
            :borderTypeFlag.sync="liActiveBorderTypeFlag"
            :borderRadius.sync="liActiveBorderRadius"
            :borderTopLeftRadius.sync="liActiveBorderTopLeftRadius"
            :borderTopRightRadius.sync="liActiveBorderTopRightRadius"
            :borderBottomRightRadius.sync="liActiveBorderBottomRightRadius"
            :borderBottomLeftRadius.sync="liActiveBorderBottomLeftRadius"
          />
          <div class="mt16">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="liActiveBorderWidth"
              :borderStyle.sync="liActiveBorderStyle"
              :borderColor.sync="liActiveBorderColor"
              :borderIsThemeColor.sync="liActiveBorderIsThemeColor"
            />
          </div>
          <div class="mt12">
            <cx-padding
              :paddingTypeFlag.sync="liActivePaddingTypeFlag"
              :padding.sync="liActivePadding"
              :paddingTop.sync="liActivePaddingTop"
              :paddingRight.sync="liActivePaddingRight"
              :paddingBottom.sync="liActivePaddingBottom"
              :paddingLeft.sync="liActivePaddingLeft"
            />
          </div>
          <div class="mt12">
            <cx-background :background.sync="liActiveBackground" imgType="10" />
          </div>
          <div class="content-item mt12">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('liActiveB')"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="liActiveBoxShadowH"
              :boxShadowV.sync="liActiveBoxShadowV"
              :boxShadowBlur.sync="liActiveBoxShadowBlur"
              :boxShadowSpread.sync="liActiveBoxShadowSpread"
              :boxShadowColor.sync="liActiveBoxShadowColor"
            ></box-shadow>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="activeType == 2"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '9')"
        title="更多按钮"
        name="9"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '9')">
          <div class="">
            <span class="inlineMiddle">文字样式</span>
            <text-setting-complex-update
              class="mt8"
              :fontFamily.sync="moreActiveFontFamily"
              :fontSize.sync="moreActiveFontSize"
              :fontWeight.sync="moreActiveFontWeight"
              :fontStyle.sync="moreActiveFontStyle"
              :textDecoration.sync="moreActiveTextDecoration"
              :lineHeight.sync="moreActiveLineHeight"
              :lineHeightType.sync="moreActiveLineHeightType"
              :letterSpacing.sync="moreActiveLetterSpacing"
              :activeArrangement.sync="moreActiveArrangement"
              :writingMode.sync="moreActiveWritingMode"
              :textAlign.sync="moreActiveTextAlign"
              :activeArrangementOrder.sync="moreActiveArrangementOrder"
              :isThemeColor.sync="moreActiveIsThemeColor" 
              :colorArr.sync="moreActiveFontColor"
              :showOverflowSetting="true"
              :overflowTypes="['字数', '无']"
              :contentHasLimit.sync="moreActiveTextLimit"
              :contentHasLimitRadio="'字数'"
              :textLimitWords.sync="moreActiveTextLimitCount"
              :options="options"
            />
            <!-- <text-vertical-align-setting class="mt8" v-show="showActiveLiVerticalAlign" :verticalAlign.sync="liActiveVerticalAlign"/> -->
          </div>
          <!-- <div class="mt12">
            <el-checkbox v-model="showMoreNavIcon">显示图标</el-checkbox>
            <div v-show="showMoreNavIcon" class="content-item card mt8">
              <img-icon-upload
                class="mb12"
                :imgSrc.sync="moreActiveIconSrc"
                :iconType.sync="moreActiveIconType"
                :iconColor.sync="moreActiveIconColor"
                :resInfo.sync="moreActiveResInfo"
              />
              <div v-show="moreActiveIconSrc.length" class="content-item mb12 verticallyCenter">
                <span class="mr16 fs14">位置</span>
                <el-radio-group v-model="moreActiveIconPosition">
                  <el-radio label="left">左</el-radio>
                  <el-radio label="right">右</el-radio>
                </el-radio-group>
              </div>
              <slider-and-input class="mb12" :value.sync="moreActiveIconMargin" title="间距" :sliderMax="navWidth" suffix="px" />
              <div class="verticallyCenter mb12" v-if="moreActiveIconType === 'icon'">
                <span class="mr16 fs14">颜色</span>
                <cx-color-picker class="flex1" :isThemeColor.sync="moreActiveIconColorIsThemeColor" :colorArr.sync="moreActiveIconColor">
                </cx-color-picker>
              </div>
              <slider-and-input :value.sync="moreActiveIconWidth" title="大小" :sliderMax="navWidth" suffix="px" />
            </div>
          </div> -->
          <border-radius
            class="mt12"
            :borderTypeFlag.sync="moreActiveBorderTypeFlag"
            :borderRadius.sync="moreActiveBorderRadius"
            :borderTopLeftRadius.sync="moreActiveBorderTopLeftRadius"
            :borderTopRightRadius.sync="moreActiveBorderTopRightRadius"
            :borderBottomRightRadius.sync="moreActiveBorderBottomRightRadius"
            :borderBottomLeftRadius.sync="moreActiveBorderBottomLeftRadius"
          />
          <div class="mt16">
            <span>边框</span>
            <cx-border
              :borderWidth.sync="moreActiveBorderWidth"
              :borderStyle.sync="moreActiveBorderStyle"
              :borderColor.sync="moreActiveBorderColor"
              :borderIsThemeColor.sync="moreActiveBorderIsThemeColor"
            />
          </div>
          <div class="mt12">
            <cx-padding
              :paddingTypeFlag.sync="moreActivePaddingTypeFlag"
              :padding.sync="moreActivePadding"
              :paddingTop.sync="moreActivePaddingTop"
              :paddingRight.sync="moreActivePaddingRight"
              :paddingBottom.sync="moreActivePaddingBottom"
              :paddingLeft.sync="moreActivePaddingLeft"
            />
          </div>
          <div class="mt12">
            <cx-background :background.sync="moreActiveBackground" imgType="10" />
          </div>
          <div class="content-item mt12">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('moreActiveB')"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="moreActiveBoxShadowH"
              :boxShadowV.sync="moreActiveBoxShadowV"
              :boxShadowBlur.sync="moreActiveBoxShadowBlur"
              :boxShadowSpread.sync="moreActiveBoxShadowSpread"
              :boxShadowColor.sync="moreActiveBoxShadowColor"
            ></box-shadow>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import button from "./settings/button"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  components: {
    controlWidthAndSizeAndZindex,
    Button: button
  },
  props: {
    options: Object,
    activeType: String
  },
  data() {
    return {
      activeNames: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      collapseActiveNames: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      allCollapseNames: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      this1: this,
      alignmentTypeOptions: [
        {
          value: "left",
          label: "左对齐",
          iconClass: "icon-portal-Align-left"
        },
        {
          value: "center",
          label: "居中对齐",
          iconClass: "icon-portal-Center-lr"
        },
        {
          value: "right",
          label: "右对齐",
          iconClass: "icon-portal-Align-right"
        }
      ],
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      directionList: [
        {
          className: "icon-portal-direction-down",
          label: "vertical",
          title: "垂直"
        },
        {
          className: "icon-portal-direction-right",
          label: "horizontal",
          title: "水平"
        }
      ],
      translate: 0,
      widthTypeList: [
        {
          label: true,
          title: "平均列宽"
        },
        {
          label: false,
          title: "自定义"
        }
      ],
      translate1: 0,
      changeWayList: [
        {
          label: "scroll",
          title: "滚动条"
        },
        {
          label: "button",
          title: "切换按钮"
        }
      ],
      translate2: 0,
      showVerticalAlign: true,
      showActiveVerticalAlign: true,
      showLiVerticalAlign: true,
      showActiveLiVerticalAlign: true
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  },
  methods: {
    changeBorderRadiusType(value, hoverFlag) {
      let propName = hoverFlag ? hoverFlag + "BorderTypeFlag" : "borderTypeFlag"
      if (this[propName] === value) {
        return
      }
      this[propName] = value
      // 暂时只处理默认情况  悬浮情况后面有可能会有改动
      this.borderTopRightRadius = this.borderTopLeftRadius
      this.borderBottomLeftRadius = this.borderTopLeftRadius
      this.borderBottomRightRadius = this.borderTopLeftRadius
    },
    addBoxshadow(prefix) {
      if (!Array.isArray(this[`${prefix}oxShadowH`])) {
        this[`${prefix}oxShadowH`] = [this[`${prefix}oxShadowH`]]
        this[`${prefix}oxShadowV`] = [this[`${prefix}oxShadowV`]]
        this[`${prefix}oxShadowBlur`] = [this[`${prefix}oxShadowBlur`]]
        this[`${prefix}oxShadowSpread`] = [this[`${prefix}oxShadowSpread`]]
        this[`${prefix}oxShadowColor`] = [this[`${prefix}oxShadowColor`]]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this[`${prefix}oxShadowH`]))
      let boxShadowV = JSON.parse(JSON.stringify(this[`${prefix}oxShadowV`]))
      let boxShadowBlur = JSON.parse(JSON.stringify(this[`${prefix}oxShadowBlur`]))
      let boxShadowSpread = JSON.parse(JSON.stringify(this[`${prefix}oxShadowSpread`]))
      let boxShadowColor = JSON.parse(JSON.stringify(this[`${prefix}oxShadowColor`]))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this[`${prefix}oxShadowH`] = boxShadowH
      this[`${prefix}oxShadowV`] = boxShadowV
      this[`${prefix}oxShadowBlur`] = boxShadowBlur
      this[`${prefix}oxShadowSpread`] = boxShadowSpread
      this[`${prefix}oxShadowColor`] = boxShadowColor
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    explainDialogClick() {
      this.explainDialog = true
      this.explainTitle = "尺寸自动"
      this.explainTips = "开启后，下拉列表项的宽度、高度会自适应至合适高度，不能手动调整"
    },
    changeDirection(value) {
      this.directionMode = value
    },
    changeWidthType(value) {
      this.widthAuto = value
    },
    handleChangeWay(value) {
      this.changeWay = value
    },
    changeColLen(flag) {
      let selectOptions = this.options.selectOptions
      if (this.showColNumber === 1 && flag === 0) {
        return
      }
      if (this.showColNumber > 9 && flag === 1) {
        return
      }
      this.showColNumber = flag === 0 ? this.showColNumber - 1 : this.showColNumber + 1
    },
    changeWidthHandle($event, index) {
      const widthList = [...this.widthList]
      widthList[index] = $event
      this.$changeOptionsEV(widthList, "widthList", false)
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    alignmentType: {
      get() {
        return this.options.alignmentType || "left"
      },
      set(val) {
        this.$changeOptionsEV(val, "alignmentType", false)
      }
    },
    directionMode: {
      get() {
        let index = this.directionList.findIndex(item => item.label === this.options.mode)
        // 75 一个滑块的宽度
        this.translate = 75 * index
        return this.options.mode
      },
      set(val) {
        this.$changeOptionsEV(val, "mode", false)
      }
    },
    collapse: {
      get() {
        return this.options.collapse
      },
      set(val) {
        this.$changeOptionsEV(val, "collapse", false)
      }
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        newVal !== this.opacity && this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    arrangement() {
      return this.options.textAlign
    },
    arrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(val) {
        this.$changeOptionsEV(val, "bgColor", false)
      }
    },
    bgIsThemeColor: {
      get() {
        return this.options.bgIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "bgIsThemeColor", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "borderColor", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "borderWidth", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "borderStyle", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "borderIsThemeColor", false)
      }
    },
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "paddingTypeFlag", "paddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.options.borderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.options.borderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.options.borderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    widthAuto: {
      get() {
        let index = this.widthTypeList.findIndex(item => item.label === this.options.widthAuto)
        // 75 一个滑块的宽度
        this.translate1 = 75 * index
        return this.options.widthAuto
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "widthAuto", false)
      }
    },
    navWidth: {
      get() {
        return this.options.navWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "navWidth", false)
      }
    },

    /* 一级菜单默认样式start */
    iconPosition: {
      get() {
        return this.options.iconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPosition", false)
      }
    },
    iconSrc: {
      get() {
        return this.options.iconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconSrc", false)
      }
    },
    iconType: {
      get() {
        return this.options.iconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconType", false)
      }
    },
    iconWidth: {
      get() {
        return this.options.iconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconWidth", false)
      }
    },
    iconMargin: {
      get() {
        return this.options.iconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    iconColor: {
      get() {
        return this.options.iconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    iconColorIsThemeColor: {
      get() {
        return this.options.iconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColorIsThemeColor", false)
      }
    },
    topNavBackground: {
      get() {
        let background = this.options.topNavBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.topNavBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "topNavBackground", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBackground", false)
      }
    },
    topNavTextLimitCount: {
      get() {
        return this.options.topNavTextLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavTextLimitCount", false)
      }
    },
    topNavTextLimit: {
      get() {
        return this.options.topNavTextLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavTextLimit", false)
      }
    },
    showTopNavIcon: {
      get() {
        return this.options.showTopNavIcon
      },
      set(val) {
        this.$changeOptionsEV(val, "showTopNavIcon", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "fontWeight", false)
      }
    },
    fontColor: {
      get() {
        return this.options.fontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "fontColor", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "letterSpacing", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    lineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lineHeightType", "lineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    verticalAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "verticalAlign", "verticalAlign", "top")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "verticalAlign", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
        this.showVerticalAlign = newVal === "vertical-lr" ? false : true
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    topNavBorderColor: {
      get() {
        return this.options.topNavBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderColor", false)
      }
    },
    topNavBorderWidth: {
      get() {
        return this.options.topNavBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderWidth", false)
      }
    },
    topNavBorderStyle: {
      get() {
        return this.options.topNavBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderStyle", false)
      }
    },
    topNavBorderIsThemeColor: {
      get() {
        return this.options.topNavBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "topNavBorderIsThemeColor", false)
      }
    },
    topNavBorderTypeFlag: {
      get() {
        let defaultType = 1
        // if (!this.options.hasOwnProperty("topNavBorderTypeFlag")) {
        //   if (
        //     ((this.topNavBorderTopLeftRadius === this.topNavBorderTopRightRadius) ===
        //       this.topNavBorderBottomLeftRadius) ===
        //     this.topNavBorderBottomRightRadius
        //   ) {
        //     defaultType = 2
        //   }
        // }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.topNavBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTypeFlag", false)
      }
    },
    topNavBorderRadius: {
      get() {
        return Number(this.options.topNavBorderRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "topNavBorderRadius",
            "topNavBorderTopLeftRadius",
            "topNavBorderTopRightRadius",
            "topNavBorderBottomRightRadius",
            "topNavBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    topNavBorderTopLeftRadius: {
      get() {
        return Number(this.options.topNavBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTopLeftRadius", false)
      }
    },
    topNavBorderTopRightRadius: {
      get() {
        return Number(this.options.topNavBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderTopRightRadius", false)
      }
    },
    topNavBorderBottomRightRadius: {
      get() {
        return Number(this.options.topNavBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderBottomRightRadius", false)
      }
    },
    topNavBorderBottomLeftRadius: {
      get() {
        return Number(this.options.topNavBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBorderBottomLeftRadius", false)
      }
    },
    topNavBoxShadowColor: {
      get() {
        return this.options.topNavBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowColor", false)
      }
    },
    topNavBoxShadowH: {
      get() {
        return this.options.topNavBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowH", false)
      }
    },
    topNavBoxShadowV: {
      get() {
        return this.options.topNavBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowV", false)
      }
    },
    topNavBoxShadowBlur: {
      get() {
        return this.options.topNavBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowBlur", false)
      }
    },
    topNavBoxShadowSpread: {
      get() {
        return this.options.topNavBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavBoxShadowSpread", false)
      }
    },
    // 边距
    topNavPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("topNavPaddingTypeFlag")) {
          if (
            ((this.topNavPaddingTop === this.topNavPaddingRight) === this.topNavPaddingLeft) ===
            this.topNavPaddingBottom
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingTypeFlag", "topNavPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingTypeFlag", false)
      }
    },
    topNavPadding: {
      get() {
        // return this.options.padding || 0
        return this.checkAndSetPrimaryVal(this.options, "topNavPadding", "topNavPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPadding", false)
      }
    },
    topNavPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingTop", "topNavPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingTop", false)
      }
    },
    topNavPaddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingRight", "topNavPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingRight", false)
      }
    },
    topNavPaddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingLeft", "topNavPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingLeft", false)
      }
    },
    topNavPaddingBottom: {
      get() {
        // return this.options.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.options, "topNavPaddingBottom", "topNavPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topNavPaddingBottom", false)
      }
    },
    /* 一级菜单默认样式end */
    /* 二级菜单默认样式start */
    liIsSameSize: {
      get() {
        return this.options.liIsSameSize
      },
      set(val) {
        this.$changeOptionsEV(val, "liIsSameSize", false)
      }
    },
    liWidth: {
      get() {
        return this.options.liWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "liWidth", false)
      }
    },
    liHeight: {
      get() {
        return this.options.liHeight
      },
      set(val) {
        this.$changeOptionsEV(val, "liHeight", false)
      }
    },
    showPlaceHolderText: {
      get() {
        return this.options.showPlaceHolderText
      },
      set(val) {
        this.$changeOptionsEV(val, "showPlaceHolderText", false)
      }
    },
    placeholderText: {
      get() {
        return this.options.placeholderText
      },
      set(val) {
        this.$changeOptionsEV(val, "placeholderText", false)
      }
    },
    liBackground: {
      get() {
        let background = this.options.liBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.liBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.liBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "liBackground", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "liBackground", false)
      }
    },
    liBgColor: {
      get() {
        return this.options.liBgColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liBgColor", false)
      }
    },
    liBgIsThemeColor: {
      get() {
        return this.options.liBgIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liBgIsThemeColor", false)
      }
    },
    liBoxShadowColor: {
      get() {
        return this.options.liBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBoxShadowColor", false)
      }
    },
    liBoxShadowH: {
      get() {
        return this.options.liBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBoxShadowH", false)
      }
    },
    liBoxShadowV: {
      get() {
        return this.options.liBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBoxShadowV", false)
      }
    },
    liBoxShadowBlur: {
      get() {
        return this.options.liBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBoxShadowBlur", false)
      }
    },
    liBoxShadowSpread: {
      get() {
        return this.options.liBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBoxShadowSpread", false)
      }
    },
    liBorderTypeFlag: {
      get() {
        let defaultType = 1
        // if (!this.options.hasOwnProperty("topNavBorderTypeFlag")) {
        //   if (
        //     ((this.topNavBorderTopLeftRadius === this.topNavBorderTopRightRadius) ===
        //       this.topNavBorderBottomLeftRadius) ===
        //     this.topNavBorderBottomRightRadius
        //   ) {
        //     defaultType = 2
        //   }
        // }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.liBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTypeFlag", false)
      }
    },
    liBorderRadius: {
      get() {
        return Number(this.options.liBorderRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "liBorderRadius",
            "liBorderTopLeftRadius",
            "liBorderTopRightRadius",
            "liBorderBottomRightRadius",
            "liBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    liBorderTopLeftRadius: {
      get() {
        return Number(this.options.liBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTopLeftRadius", false)
      }
    },
    liBorderTopRightRadius: {
      get() {
        return Number(this.options.liBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderTopRightRadius", false)
      }
    },
    liBorderBottomRightRadius: {
      get() {
        return Number(this.options.liBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderBottomRightRadius", false)
      }
    },
    liBorderBottomLeftRadius: {
      get() {
        return Number(this.options.liBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liBorderBottomLeftRadius", false)
      }
    },
    liBorderColor: {
      get() {
        return this.options.liBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderColor", false)
      }
    },
    liBorderWidth: {
      get() {
        return this.options.liBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderWidth", false)
      }
    },
    liBorderStyle: {
      get() {
        return this.options.liBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderStyle", false)
      }
    },
    liBorderIsThemeColor: {
      get() {
        return this.options.liBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liBorderIsThemeColor", false)
      }
    },
    liArrangement() {
      return this.options.liTextAlign
    },
    liArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liWritingMode", false)
      }
    },
    liLetterSpacing: {
      get() {
        return this.options.liLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liLetterSpacing", false)
      }
    },
    liLineHeight: {
      get() {
        return this.options.liLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liLineHeight", false)
      }
    },
    liLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liLineHeightType", "liLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liLineHeightType", false)
      }
    },
    liIsThemeColor: {
      get() {
        return this.options.liIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIsThemeColor", false)
      }
    },
    liFontStyle: {
      get() {
        return this.options.liFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liFontStyle", false)
      }
    },
    liTextAlign: {
      get() {
        return this.options.liTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextAlign", false)
      }
    },
    liTextIsThemeColor: {
      get() {
        return this.options.liTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextIsThemeColor", false)
      }
    },
    liWritingMode: {
      get() {
        return this.options.liWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liWritingMode", false)
      }
    },
    liVerticalAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liVerticalAlign", "liVerticalAlign", "top")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liVerticalAlign", false)
      }
    },
    liTextDecoration: {
      get() {
        return this.options.liTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liTextDecoration", false)
      }
    },
    liFontFamily: {
      get() {
        return this.options.liFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontFamily", false)
      }
    },
    liFontSize: {
      get() {
        return this.options.liFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontSize", false)
      }
    },
    liFontWeight: {
      get() {
        return this.options.liFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontWeight", false)
      }
    },
    liFontColor: {
      get() {
        return this.options.liFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liFontColor", false)
      }
    },
    liTextLimitCount: {
      get() {
        return this.options.liTextLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "liTextLimitCount", false)
      }
    },
    liTextLimit: {
      get() {
        return this.options.liTextLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "liTextLimit", false)
      }
    },
    showLiNavIcon: {
      get() {
        return this.options.showLiNavIcon
      },
      set(val) {
        this.$changeOptionsEV(val, "showLiNavIcon", false)
      }
    },
    liIconPosition: {
      get() {
        return this.options.liIconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconPosition", false)
      }
    },
    liIconSrc: {
      get() {
        return this.options.iconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconSrc", false)
      }
    },
    liIconType: {
      get() {
        return this.options.iconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconType", false)
      }
    },
    liIconWidth: {
      get() {
        return this.options.iconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconWidth", false)
      }
    },
    liIconMargin: {
      get() {
        return this.options.liIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconMargin", false)
      }
    },
    liIconColor: {
      get() {
        return this.options.liIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconColor", false)
      }
    },
    liIconColorIsThemeColor: {
      get() {
        return this.options.liIconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liIconColorIsThemeColor", false)
      }
    },
    liResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liResInfo", "liResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liResInfo", false)
      }
    },
    liPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liPaddingTypeFlag")) {
          if (((this.liPaddingTop === this.liPaddingRight) === this.liPaddingLeft) === this.liPaddingBottom) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "liPaddingTypeFlag", "liPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingTypeFlag", false)
      }
    },
    liPadding: {
      get() {
        // return this.options.padding || 0
        return this.checkAndSetPrimaryVal(this.options, "liPadding", "liPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPadding", false)
      }
    },
    liPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liPaddingTop", "liPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingTop", false)
      }
    },
    liPaddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "liPaddingRight", "liPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingRight", false)
      }
    },
    liPaddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "liPaddingLeft", "liPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingLeft", false)
      }
    },
    liPaddingBottom: {
      get() {
        // return this.options.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.options, "liPaddingBottom", "liPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liPaddingBottom", false)
      }
    },
    lineMargin: {
      get() {
        return this.options.lineMargin || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineMargin", false)
      }
    },
    columnMargin: {
      get() {
        return this.options.columnMargin || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "columnMargin", false)
      }
    },
    /* 二级菜单默认样式end */

    /* 一级菜单选中样式start */
    activeArrangement() {
      return this.options.activeTextAlign
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.activeWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "activeWritingMode", false)
      }
    },
    activeBgColor: {
      get() {
        let background = this.options.activeBgColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.activeBgColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color:
              this.options.activeBgColor && this.options.activeBgColor.color
                ? this.options.activeBgColor.color
                : this.options.activeBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "activeBgColor", false, false, false, true)
        return newBackground
        // return this.options.activeBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColor", false)
      }
    },
    activeBgIsThemeColor: {
      get() {
        return this.options.activeBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgIsThemeColor", false)
      }
    },
    activeLetterSpacing: {
      get() {
        return this.options.activeLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "activeLetterSpacing", false)
      }
    },
    activeLineHeight: {
      get() {
        return this.options.activeLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeight", false)
      }
    },
    activeLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeLineHeightType", "activeLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLineHeightType", false)
      }
    },
    activeFontStyle: {
      get() {
        return this.options.activeFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontStyle", false)
      }
    },
    activeTextAlign: {
      get() {
        return this.options.activeTextAlign
      },
      set(newVal) {
        console.log('activeTextAlign', newVal)
        this.$changeOptionsEV(newVal, "activeTextAlign", false)
      }
    },
    activeTextIsThemeColor: {
      get() {
        return this.options.activeTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextIsThemeColor", false)
      }
    },
    activeWritingMode: {
      get() {
        return this.options.activeWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeWritingMode", false)
      }
    },
    activeTextDecoration: {
      get() {
        return this.options.activeTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTextDecoration", false)
      }
    },
    activeFontFamily: {
      get() {
        return this.options.activeFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontFamily", false)
      }
    },
    activeFontSize: {
      get() {
        return this.options.activeFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontSize", false)
      }
    },
    activeFontWeight: {
      get() {
        return this.options.activeFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontWeight", false)
      }
    },
    activeFontColor: {
      get() {
        return this.options.activeFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontColor", false)
      }
    },
    activeVerticalAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeVerticalAlign", "activeVerticalAlign", "top")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeVerticalAlign", false)
      }
    },
    activeShowTopNavIcon: {
      get() {
        return this.options.activeShowTopNavIcon
      },
      set(val) {
        this.$changeOptionsEV(val, "activeShowTopNavIcon", false)
      }
    },
    activeResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeResInfo", "activeResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeResInfo", false)
      }
    },
    activeIconSrc: {
      get() {
        return this.options.activeIconSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconSrc", false)
      }
    },
    activeIconType: {
      get() {
        return this.options.activeIconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconType", false)
      }
    },
    activeIconWidth: {
      get() {
        return this.options.activeIconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconWidth", false)
      }
    },
    activeIconPosition: {
      get() {
        return this.options.activeIconPosition || "right"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconPosition", false)
      }
    },
    activeIconMargin: {
      get() {
        return this.options.activeIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconMargin", false)
      }
    },
    activeIconColor: {
      get() {
        return this.options.activeIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconColor", false)
      }
    },
    activeIconColorIsThemeColor: {
      get() {
        return this.options.activeIconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeIconColorIsThemeColor", false)
      }
    },
    activeTopNavPaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("activeTopNavPaddingTypeFlag")) {
          if (
            ((this.activeTopNavPaddingTop === this.activeTopNavPaddingRight) === this.activeTopNavPaddingLeft) ===
            this.activeTopNavPaddingBottom
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(
          this.options,
          "activeTopNavPaddingTypeFlag",
          "activeTopNavPaddingTypeFlag",
          defaultType
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavPaddingTypeFlag", false)
      }
    },
    activeTopNavPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeTopNavPadding", "activeTopNavPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavPadding", false)
      }
    },
    activeTopNavPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeTopNavPaddingTop", "activeTopNavPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavPaddingTop", false)
      }
    },
    activeTopNavPaddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "activeTopNavPaddingRight", "activeTopNavPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavPaddingRight", false)
      }
    },
    activeTopNavPaddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "activeTopNavPaddingLeft", "activeTopNavPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavPaddingLeft", false)
      }
    },
    activeTopNavPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeTopNavPaddingBottom", "activeTopNavPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavPaddingBottom", false)
      }
    },
    activeTopNavBorderColor: {
      get() {
        return this.options.activeTopNavBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "activeTopNavBorderColor", false)
      }
    },
    activeTopNavBorderWidth: {
      get() {
        return this.options.activeTopNavBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "activeTopNavBorderWidth", false)
      }
    },
    activeTopNavBorderStyle: {
      get() {
        return this.options.activeTopNavBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "activeTopNavBorderStyle", false)
      }
    },
    activeTopNavBorderIsThemeColor: {
      get() {
        return this.options.activeTopNavBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "activeTopNavBorderIsThemeColor", false)
      }
    },
    activeTopNavBorderTypeFlag: {
      get() {
        return this.options.activeTopNavBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavBorderTypeFlag", false)
      }
    },
    activeTopNavBorderRadius: {
      get() {
        return Number(this.options.activeTopNavBorderRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "activeTopNavBorderRadius",
            "activeTopNavBorderTopLeftRadius",
            "activeTopNavBorderTopRightRadius",
            "activeTopNavBorderBottomRightRadius",
            "activeTopNavBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    activeTopNavBorderTopLeftRadius: {
      get() {
        return Number(this.options.activeTopNavBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavBorderTopLeftRadius", false)
      }
    },
    activeTopNavBorderTopRightRadius: {
      get() {
        return Number(this.options.activeTopNavBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavBorderTopRightRadius", false)
      }
    },
    activeTopNavBorderBottomRightRadius: {
      get() {
        return Number(this.options.topNavBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavBorderBottomRightRadius", false)
      }
    },
    activeTopNavBorderBottomLeftRadius: {
      get() {
        return Number(this.options.activeTopNavBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavBorderBottomLeftRadius", false)
      }
    },
    activeTopNavBoxShadowColor: {
      get() {
        return this.options.activeTopNavBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavBoxShadowColor", false)
      }
    },
    activeTopNavBoxShadowH: {
      get() {
        return this.options.activeTopNavBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavBoxShadowH", false)
      }
    },
    activeTopNavBoxShadowV: {
      get() {
        return this.options.activeTopNavBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavBoxShadowV", false)
      }
    },
    activeTopNavBoxShadowBlur: {
      get() {
        return this.options.activeTopNavBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavBoxShadowBlur", false)
      }
    },
    activeTopNavBoxShadowSpread: {
      get() {
        return this.options.activeTopNavBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeTopNavBoxShadowSpread", false)
      }
    },
    /* 一级菜单选中样式end */

    /* 二级菜单选中样式start */
    liActiveBgColor: {
      get() {
        return this.options.liActiveBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBgColor", false)
      }
    },
    liActiveBgIsThemeColor: {
      get() {
        return this.options.liActiveBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBgIsThemeColor", false)
      }
    },
    liActiveBorderWidth: {
      get() {
        return this.options.liActiveBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderWidth", false)
      }
    },
    liActiveBorderColor: {
      get() {
        return this.options.liActiveBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderColor", false)
      }
    },
    liActiveBorderStyle: {
      get() {
        return this.options.liActiveBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderStyle", false)
      }
    },
    liActiveBorderIsThemeColor: {
      get() {
        return this.options.liActiveBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderIsThemeColor", false)
      }
    },
    liActiveArrangement() {
      return this.options.liActiveTextAlign
    },
    liActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.liActiveWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "liActiveWritingMode", false)
      }
    },
    liActiveLetterSpacing: {
      get() {
        return this.options.liActiveLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "liActiveLetterSpacing", false)
      }
    },
    liActiveLineHeight: {
      get() {
        return this.options.liActiveLineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveLineHeight", false)
      }
    },
    liActiveLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveLineHeightType", "liActiveLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveLineHeightType", false)
      }
    },
    liActiveFontStyle: {
      get() {
        return this.options.liActiveFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontStyle", false)
      }
    },
    liActiveTextAlign: {
      get() {
        return this.options.liActiveTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextAlign", false)
      }
    },
    liActiveTextIsThemeColor: {
      get() {
        return this.options.liActiveTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextIsThemeColor", false)
      }
    },
    liActiveWritingMode: {
      get() {
        return this.options.liActiveWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveWritingMode", false)
      }
    },
    liActiveTextDecoration: {
      get() {
        return this.options.liActiveTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveTextDecoration", false)
      }
    },

    liActiveFontFamily: {
      get() {
        return this.options.liActiveFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontFamily", false)
      }
    },
    liActiveFontSize: {
      get() {
        return this.options.liActiveFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontSize", false)
      }
    },
    liActiveFontWeight: {
      get() {
        return this.options.liActiveFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontWeight", false)
      }
    },
    liActiveFontColor: {
      get() {
        return this.options.liActiveFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveFontColor", false)
      }
    },
    liActiveVerticalAlign: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveVerticalAlign", "liActiveVerticalAlign", "top")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveVerticalAlign", false)
      }
    },
    liActiveIsSameActive: {
      get() {
        return this.options.liActiveIsSameActive
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIsSameActive", false)
      }
    },
    liActiveIsThemeColor: {
      get() {
        return this.options.liActiveIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIsThemeColor", false)
      }
    },
    activeShowLiNavIcon: {
      get() {
        return this.options.activeShowLiNavIcon
      },
      set(val) {
        this.$changeOptionsEV(val, "activeShowLiNavIcon", false)
      }
    },
    liActiveIconPosition: {
      get() {
        return this.options.liActiveIconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconPosition", false)
      }
    },
    liActiveIconSrc: {
      get() {
        return this.options.liActiveIconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconSrc", false)
      }
    },
    liActiveIconType: {
      get() {
        return this.options.liActiveIconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconType", false)
      }
    },
    liActiveIconWidth: {
      get() {
        return this.options.liActiveIconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconWidth", false)
      }
    },
    liActiveIconMargin: {
      get() {
        return this.options.liActiveIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconMargin", false)
      }
    },
    liActiveIconColor: {
      get() {
        return this.options.liActiveIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconColor", false)
      }
    },
    liActiveIconColorIsThemeColor: {
      get() {
        return this.options.liActiveIconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveIconColorIsThemeColor", false)
      }
    },
    liActiveResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActiveResInfo", "liActiveResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveResInfo", false)
      }
    },
    liActivePaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("liActivePaddingTypeFlag")) {
          if (
            ((this.liActivePaddingTop === this.liActivePaddingRight) === this.liActivePaddingLeft) ===
            this.liActivePaddingBottom
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(
          this.options,
          "liActivePaddingTypeFlag",
          "liActivePaddingTypeFlag",
          defaultType
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActivePaddingTypeFlag", false)
      }
    },
    liActivePadding: {
      get() {
        // return this.options.padding || 0
        return this.checkAndSetPrimaryVal(this.options, "liActivePadding", "liActivePadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActivePadding", false)
      }
    },
    liActivePaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "liActivePaddingTop", "liActivePaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActivePaddingTop", false)
      }
    },
    liActivePaddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "liActivePaddingRight", "liActivePaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActivePaddingRight", false)
      }
    },
    liActivePaddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "liActivePaddingLeft", "liActivePaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActivePaddingLeft", false)
      }
    },
    liActivePaddingBottom: {
      get() {
        // return this.options.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.options, "liActivePaddingBottom", "liActivePaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActivePaddingBottom", false)
      }
    },
    liActiveBackground: {
      get() {
        let background = this.options.liActiveBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.liActiveBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.liActiveBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "liActiveBackground", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "liActiveBackground", false)
      }
    },
    liActiveBgColor: {
      get() {
        return this.options.liActiveBgColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liActiveBgColor", false)
      }
    },
    liActiveBgIsThemeColor: {
      get() {
        return this.options.liActiveBgIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "liActiveBgIsThemeColor", false)
      }
    },
    liActiveBoxShadowColor: {
      get() {
        return this.options.liActiveBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBoxShadowColor", false)
      }
    },
    liActiveBoxShadowH: {
      get() {
        return this.options.liActiveBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBoxShadowH", false)
      }
    },
    liActiveBoxShadowV: {
      get() {
        return this.options.liActiveBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBoxShadowV", false)
      }
    },
    liActiveBoxShadowBlur: {
      get() {
        return this.options.liActiveBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBoxShadowBlur", false)
      }
    },
    liActiveBoxShadowSpread: {
      get() {
        return this.options.liActiveBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBoxShadowSpread", false)
      }
    },
    liActiveBorderTypeFlag: {
      get() {
        return this.options.liActiveBorderTypeFlag || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderTypeFlag", false)
      }
    },
    liActiveBorderRadius: {
      get() {
        return Number(this.options.liActiveBorderRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "liActiveBorderRadius",
            "liActiveBorderTopLeftRadius",
            "liActiveBorderTopRightRadius",
            "liActiveBorderBottomRightRadius",
            "liActiveBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    liActiveBorderTopLeftRadius: {
      get() {
        return Number(this.options.liActiveBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderTopLeftRadius", false)
      }
    },
    liActiveBorderTopRightRadius: {
      get() {
        return Number(this.options.liActiveBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderTopRightRadius", false)
      }
    },
    liActiveBorderBottomRightRadius: {
      get() {
        return Number(this.options.liActiveBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderBottomRightRadius", false)
      }
    },
    liActiveBorderBottomLeftRadius: {
      get() {
        return Number(this.options.liActiveBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "liActiveBorderBottomLeftRadius", false)
      }
    },
    /* 二级菜单选中样式end */
    /* 更多按钮默认样式start */
    moreContent: {
      get() {
        return this.options.moreContent || "更多"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreContent", false)
      }
    },
    moreBgColor: {
      get() {
        return this.options.moreBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBgColor", false)
      }
    },
    moreBgIsThemeColor: {
      get() {
        return this.options.moreBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBgIsThemeColor", false)
      }
    },
    moreBorderWidth: {
      get() {
        return this.options.moreBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBorderWidth", false)
      }
    },
    moreBorderColor: {
      get() {
        return this.options.moreBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBorderColor", false)
      }
    },
    moreBorderStyle: {
      get() {
        return this.options.moreBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBorderStyle", false)
      }
    },
    moreBorderIsThemeColor: {
      get() {
        return this.options.moreBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBorderIsThemeColor", false)
      }
    },
    moreArrangement() {
      return this.options.moreTextAlign
    },
    moreArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.moreWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "moreWritingMode", false)
      }
    },
    moreLetterSpacing: {
      get() {
        return this.options.moreLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "moreLetterSpacing", false)
      }
    },
    moreLineHeight: {
      get() {
        return this.options.moreLineHeight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreLineHeight", false)
      }
    },
    moreLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "moreLineHeightType", "moreLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreLineHeightType", false)
      }
    },
    moreFontStyle: {
      get() {
        return this.options.moreFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreFontStyle", false)
      }
    },
    moreTextAlign: {
      get() {
        return this.options.moreTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreTextAlign", false)
      }
    },
    moreTextIsThemeColor: {
      get() {
        return this.options.moreTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreTextIsThemeColor", false)
      }
    },
    moreWritingMode: {
      get() {
        return this.options.moreWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreWritingMode", false)
      }
    },
    moreTextDecoration: {
      get() {
        return this.options.moreTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreTextDecoration", false)
      }
    },
    moreFontFamily: {
      get() {
        return this.options.moreFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreFontFamily", false)
      }
    },
    moreFontSize: {
      get() {
        return this.options.moreFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreFontSize", false)
      }
    },
    moreFontWeight: {
      get() {
        return this.options.moreFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreFontWeight", false)
      }
    },
    moreFontColor: {
      get() {
        return this.options.moreFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreFontColor", false)
      }
    },
    moreIsSameActive: {
      get() {
        return this.options.moreIsSameActive
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreIsSameActive", false)
      }
    },
    moreIsThemeColor: {
      get() {
        return this.options.moreIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreIsThemeColor", false)
      }
    },
    activeShowLiNavIcon: {
      get() {
        return this.options.activeShowLiNavIcon
      },
      set(val) {
        this.$changeOptionsEV(val, "activeShowLiNavIcon", false)
      }
    },

    moreTextLimitCount: {
      get() {
        return this.options.moreTextLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "moreTextLimitCount", false)
      }
    },
    moreTextLimit: {
      get() {
        return this.options.moreTextLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "moreTextLimit", false)
      }
    },
    showMoreNavIcon: {
      get() {
        return this.options.showMoreNavIcon
      },
      set(val) {
        this.$changeOptionsEV(val, "showMoreNavIcon", false)
      }
    },
    moreIconPosition: {
      get() {
        return this.options.moreIconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreIconPosition", false)
      }
    },
    moreIconSrc: {
      get() {
        return this.options.moreIconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreIconSrc", false)
      }
    },
    moreIconType: {
      get() {
        return this.options.moreIconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreIconType", false)
      }
    },
    moreIconWidth: {
      get() {
        return this.options.moreIconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreIconWidth", false)
      }
    },
    moreIconMargin: {
      get() {
        return this.options.moreIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreIconMargin", false)
      }
    },
    moreIconColor: {
      get() {
        return this.options.moreIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreIconColor", false)
      }
    },
    moreIconColorIsThemeColor: {
      get() {
        return this.options.moreIconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreIconColorIsThemeColor", false)
      }
    },
    moreResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "moreResInfo", "moreResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreResInfo", false)
      }
    },
    morePaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("morePaddingTypeFlag")) {
          if (((this.morePaddingTop === this.morePaddingRight) === this.morePaddingLeft) === this.morePaddingBottom) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "morePaddingTypeFlag", "morePaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "morePaddingTypeFlag", false)
      }
    },
    morePadding: {
      get() {
        // return this.options.padding || 0
        return this.checkAndSetPrimaryVal(this.options, "morePadding", "morePadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "morePadding", false)
      }
    },
    morePaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "morePaddingTop", "morePaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "morePaddingTop", false)
      }
    },
    morePaddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "morePaddingRight", "morePaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "morePaddingRight", false)
      }
    },
    morePaddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "morePaddingLeft", "morePaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "morePaddingLeft", false)
      }
    },
    morePaddingBottom: {
      get() {
        // return this.options.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.options, "morePaddingBottom", "morePaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "morePaddingBottom", false)
      }
    },
    moreBackground: {
      get() {
        let background = this.options.moreBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.moreBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.moreBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "moreBackground", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "moreBackground", false)
      }
    },
    moreBoxShadowColor: {
      get() {
        return this.options.moreBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBoxShadowColor", false)
      }
    },
    moreBoxShadowH: {
      get() {
        return this.options.moreBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBoxShadowH", false)
      }
    },
    moreBoxShadowV: {
      get() {
        return this.options.moreBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBoxShadowV", false)
      }
    },
    moreBoxShadowBlur: {
      get() {
        return this.options.moreBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBoxShadowBlur", false)
      }
    },
    moreBoxShadowSpread: {
      get() {
        return this.options.moreBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBoxShadowSpread", false)
      }
    },
    moreBorderTypeFlag: {
      get() {
        return this.options.moreBorderTypeFlag || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBorderTypeFlag", false)
      }
    },
    moreBorderRadius: {
      get() {
        return Number(this.options.moreBorderRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "moreBorderRadius",
            "moreBorderTopLeftRadius",
            "moreBorderTopRightRadius",
            "moreBorderBottomRightRadius",
            "moreBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    moreBorderTopLeftRadius: {
      get() {
        return Number(this.options.moreBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBorderTopLeftRadius", false)
      }
    },
    moreBorderTopRightRadius: {
      get() {
        return Number(this.options.moreBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBorderTopRightRadius", false)
      }
    },
    moreBorderBottomRightRadius: {
      get() {
        return Number(this.options.moreBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBorderBottomRightRadius", false)
      }
    },
    moreBorderBottomLeftRadius: {
      get() {
        return Number(this.options.moreBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBorderBottomLeftRadius", false)
      }
    },
    /* 更多按钮默认样式end */

    /* 更多按钮选中样式start  */
    moreActiveBgColor: {
      get() {
        return this.options.moreActiveBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBgColor", false)
      }
    },
    moreActiveBgIsThemeColor: {
      get() {
        return this.options.moreActiveBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBgIsThemeColor", false)
      }
    },
    moreActiveBorderWidth: {
      get() {
        return this.options.moreActiveBorderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBorderWidth", false)
      }
    },
    moreActiveBorderColor: {
      get() {
        return this.options.moreActiveBorderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBorderColor", false)
      }
    },
    moreActiveBorderStyle: {
      get() {
        return this.options.moreActiveBorderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBorderStyle", false)
      }
    },
    moreActiveBorderIsThemeColor: {
      get() {
        return this.options.moreActiveBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBorderIsThemeColor", false)
      }
    },
    moreActiveArrangement() {
      return this.options.moreActiveTextAlign
    },
    moreActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.moreActiveWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "moreActiveWritingMode", false)
      }
    },
    moreActiveLetterSpacing: {
      get() {
        return this.options.moreActiveLetterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "moreActiveLetterSpacing", false)
      }
    },
    moreActiveLineHeight: {
      get() {
        return this.options.moreActiveLineHeight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveLineHeight", false)
      }
    },
    moreActiveLineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "moreActiveLineHeightType", "moreActiveLineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveLineHeightType", false)
      }
    },
    moreActiveFontStyle: {
      get() {
        return this.options.moreActiveFontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveFontStyle", false)
      }
    },
    moreActiveTextAlign: {
      get() {
        return this.options.moreActiveTextAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveTextAlign", false)
      }
    },
    moreActiveTextIsThemeColor: {
      get() {
        return this.options.moreActiveTextIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveTextIsThemeColor", false)
      }
    },
    moreActiveWritingMode: {
      get() {
        return this.options.moreActiveWritingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveWritingMode", false)
      }
    },
    moreActiveTextDecoration: {
      get() {
        return this.options.moreActiveTextDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveTextDecoration", false)
      }
    },
    moreActiveFontFamily: {
      get() {
        return this.options.moreActiveFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveFontFamily", false)
      }
    },
    moreActiveFontSize: {
      get() {
        return this.options.moreActiveFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveFontSize", false)
      }
    },
    moreActiveFontWeight: {
      get() {
        return this.options.moreActiveFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveFontWeight", false)
      }
    },
    moreActiveFontColor: {
      get() {
        return this.options.moreActiveFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveFontColor", false)
      }
    },
    moreActiveIsSameActive: {
      get() {
        return this.options.moreActiveIsSameActive
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveIsSameActive", false)
      }
    },
    moreActiveIsThemeColor: {
      get() {
        return this.options.moreActiveIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveIsThemeColor", false)
      }
    },
    activeShowLiNavIcon: {
      get() {
        return this.options.activeShowLiNavIcon
      },
      set(val) {
        this.$changeOptionsEV(val, "activeShowLiNavIcon", false)
      }
    },

    moreActiveTextLimitCount: {
      get() {
        return this.options.moreActiveTextLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "moreActiveTextLimitCount", false)
      }
    },
    moreActiveTextLimit: {
      get() {
        return this.options.moreActiveTextLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "moreActiveTextLimit", false)
      }
    },
    showMoreNavIcon: {
      get() {
        return this.options.showMoreNavIcon
      },
      set(val) {
        this.$changeOptionsEV(val, "showMoreNavIcon", false)
      }
    },
    moreActiveIconPosition: {
      get() {
        return this.options.moreActiveIconPosition
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveIconPosition", false)
      }
    },
    moreActiveIconSrc: {
      get() {
        return this.options.moreActiveIconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveIconSrc", false)
      }
    },
    moreActiveIconType: {
      get() {
        return this.options.moreActiveIconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveIconType", false)
      }
    },
    moreActiveIconWidth: {
      get() {
        return this.options.moreActiveIconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveIconWidth", false)
      }
    },
    moreActiveIconMargin: {
      get() {
        return this.options.moreActiveIconMargin
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveIconMargin", false)
      }
    },
    moreActiveIconColor: {
      get() {
        return this.options.moreActiveIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveIconColor", false)
      }
    },
    moreActiveIconColorIsThemeColor: {
      get() {
        return this.options.moreActiveIconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveIconColorIsThemeColor", false)
      }
    },
    moreActiveResInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "moreActiveResInfo", "moreActiveResInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveResInfo", false)
      }
    },
    moreActivePaddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("moreActivePaddingTypeFlag")) {
          if (
            ((this.moreActivePaddingTop === this.moreActivePaddingRight) === this.moreActivePaddingLeft) ===
            this.moreActivePaddingBottom
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(
          this.options,
          "moreActivePaddingTypeFlag",
          "moreActivePaddingTypeFlag",
          defaultType
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActivePaddingTypeFlag", false)
      }
    },
    moreActivePadding: {
      get() {
        // return this.options.padding || 0
        return this.checkAndSetPrimaryVal(this.options, "moreActivePadding", "moreActivePadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActivePadding", false)
      }
    },
    moreActivePaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "moreActivePaddingTop", "moreActivePaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActivePaddingTop", false)
      }
    },
    moreActivePaddingRight: {
      get() {
        // return this.options.paddingRight || 0
        return this.checkAndSetPrimaryVal(this.options, "moreActivePaddingRight", "moreActivePaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActivePaddingRight", false)
      }
    },
    moreActivePaddingLeft: {
      get() {
        // return this.options.paddingLeft || 0
        return this.checkAndSetPrimaryVal(this.options, "moreActivePaddingLeft", "moreActivePaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActivePaddingLeft", false)
      }
    },
    moreActivePaddingBottom: {
      get() {
        // return this.options.paddingBottom || 0
        return this.checkAndSetPrimaryVal(this.options, "moreActivePaddingBottom", "moreActivePaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActivePaddingBottom", false)
      }
    },
    moreActiveBackground: {
      get() {
        let background = this.options.moreActiveBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.moreActiveBackground
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.moreActiveBgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "moreActiveBackground", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "moreActiveBackground", false)
      }
    },
    moreActiveBgColor: {
      get() {
        return this.options.moreActiveBgColor
      },
      set(val) {
        this.$changeOptionsEV(val, "moreActiveBgColor", false)
      }
    },
    moreActiveBgIsThemeColor: {
      get() {
        return this.options.moreActiveBgIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "moreActiveBgIsThemeColor", false)
      }
    },
    moreActiveBoxShadowColor: {
      get() {
        return this.options.moreActiveBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBoxShadowColor", false)
      }
    },
    moreActiveBoxShadowH: {
      get() {
        return this.options.moreActiveBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBoxShadowH", false)
      }
    },
    moreActiveBoxShadowV: {
      get() {
        return this.options.moreActiveBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBoxShadowV", false)
      }
    },
    moreActiveBoxShadowBlur: {
      get() {
        return this.options.moreActiveBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBoxShadowBlur", false)
      }
    },
    moreActiveBoxShadowSpread: {
      get() {
        return this.options.moreActiveBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBoxShadowSpread", false)
      }
    },
    moreActiveBorderTypeFlag: {
      get() {
        return this.options.moreActiveBorderTypeFlag || 1
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBorderTypeFlag", false)
      }
    },
    moreActiveBorderRadius: {
      get() {
        return Number(this.options.moreActiveBorderRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "moreActiveBorderRadius",
            "moreActiveBorderTopLeftRadius",
            "moreActiveBorderTopRightRadius",
            "moreActiveBorderBottomRightRadius",
            "moreActiveBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    moreActiveBorderTopLeftRadius: {
      get() {
        return Number(this.options.moreActiveBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBorderTopLeftRadius", false)
      }
    },
    moreActiveBorderTopRightRadius: {
      get() {
        return Number(this.options.moreActiveBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBorderTopRightRadius", false)
      }
    },
    moreActiveBorderBottomRightRadius: {
      get() {
        return Number(this.options.moreActiveBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreActiveBorderBottomRightRadius", false)
      }
    },
    moreActiveBorderBottomLeftRadius: {
      get() {
        return Number(this.options.moreActiveBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "moreBorderBottomLeftRadius", false)
      }
    },
    /* 更多按钮选中样式end */

    resInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "resInfo", "resInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resInfo", false)
      }
    },
    isWrap: {
      get() {
        return this.options.hasOwnProperty("isWrap") ? this.options.isWrap : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isWrap", false)
      }
    },
    navMarginBottom: {
      get() {
        return this.options.navMarginBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "navMarginBottom", false)
      }
    },
    getTranslate() {
      return {
        transform: `translateX(${this.translate}px)`
      }
    },
    showColNumber: {
      get() {
        return this.options.hasOwnProperty("showColNumber") ? Number(this.options.showColNumber) : 8
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showColNumber", false)
      }
    },
    getTranslate1() {
      return {
        transform: `translateX(${this.translate1}px)`
      }
    },
    changeWay: {
      get() {
        let way = this.options.hasOwnProperty("changeWay") ? this.options.changeWay : "scroll"
        let index = this.changeWayList.findIndex(item => item.label === way)
        // 75 一个滑块的宽度
        this.translate2 = 75 * index
        return way
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "changeWay", false)
      }
    },
    getTranslate2() {
      return {
        transform: `translateX(${this.translate2}px)`
      }
    },
    widthList: {
      get() {
        return this.options.widthList
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "widthList", false)
      }
    }
  }
})
</script>

<style lang="scss">
.toolbar .card {
  padding: 8px;
}
.font-arrangement-btn .btn-active {
  width: calc((100% - 6px) / 2);
}
.font-arrangement-btn span.fs13 {
  font-size: 13px;
}
.mt4 {
  margin-top: 4px;
}
.set-box {
  flex: 1;
  input {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-right: 8px;
    border: none;
  }
  .btn-wrapper {
    flex: 1;
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;
    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 18px;
      cursor: pointer;
      color: var(--subTextColor);
      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }
      &:not(.disabled):hover {
        color: var(--themeColor);
      }
      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}
</style>
